import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import React, { useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'

const AboutDesc = () => {

    const AboutDescBox = useRef();

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger)

        const timeline = gsap.timeline()

        timeline.from(AboutDescBox.current.children, {
            scrollTrigger: {
                trigger: AboutDescBox.current,
                start: "0px bottom",
                end: "bottom 80%",
                scrub: 3,
            },
            opacity: 0,
            stagger: 0.1,
            x: '-100%',
        })

        return () => ScrollTrigger.getAll().forEach(t => t.kill());

    }, [])

    return (
        <AboutBox ref={AboutDescBox}>
            <h1> Hii, I am Gagan . Nice To Meet You </h1>

            <h3> I'm not your average Full Stack Web Developer – I'm your digital dreams' best friend. </h3>


            <p>Let's embark on this exciting journey together and turn your digital ambitions into a reality that inspires and drives success.</p>
            <p> Get ready to create something extraordinary – because with me as your Full Stack Web Developer, the possibilities are limitless!" </p>

            <p> Being a Full Stack developer is my passion and focus. </p>
        </AboutBox >


    )
}

export default AboutDesc

const AboutBox = styled.div`
    align-self: flex-end;
    margin-right: 8rem;
    width: 50%;
    text-align:center;
    display:flex;
    flex-direction: column;
    gap: 5rem;
    position: relative;
    overflow: hidden;

    @media only screen and (max-width: 1350px) {
        margin-right: 0rem !important;
    }
    @media only screen and (max-width: 740px) {
        align-self: center !important;
        width: 100% !important;
    }

    h1{
        font-family: var(--font1);
        font-size: 4rem;
        font-weight: 500;
        
        @media only screen and (max-width: 960px) {
            font-size: 3rem !important;
        }
        @media only screen and (max-width: 570px) {
            font-size: 2rem !important;
        }
    }

    h3{
        font-size: 1.5rem;
        letter-spacing: 0.1rem;

        @media only screen and (max-width: 960px) {
            font-size: 1rem !important;
        }

        @media only screen and (max-width: 570px) {
            font-size: 1rem !important;
        }
    }

    p{
        font-size: 1.25rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        font-family : var(--font5);

        @media only screen and (max-width: 960px) {
            font-size: 1rem !important;
        }
        @media only screen and (max-width: 570px) {
            font-size: 1rem !important;
        }
    }
`